import { Reveal } from "./Reveal";
import { Chapter } from "./Chapter";
import { useContent } from "@/lib/content";

const CINEMA_IMAGE =
  "https://images.unsplash.com/photo-1478720568477-152d9b164e26?auto=format&fit=crop&w=1600&q=80";

export const Testimonials = () => {
  const { testimonials, chapters } = useContent();
  const featured = testimonials.find((t) => t.featured) || testimonials[0];
  const others = testimonials.filter((t) => t !== featured);
  return (
  <section className="relative overflow-hidden" data-testid="testimonials-section">
    <div aria-hidden="true" className="absolute inset-0">
      <img src={CINEMA_IMAGE} alt="" className="h-full w-full object-cover opacity-[0.10] grayscale" />
      <div className="absolute inset-0 bg-ivory/60" />
    </div>
    <div className="relative mx-auto max-w-7xl px-6 md:px-12 py-32 md:py-44">
      <Chapter number="05" kicker={chapters.testimonials.kicker} title={chapters.testimonials.title} id="testimonials" />
      {featured && (
        <Reveal delay={0.1}>
          <figure className="mt-20 max-w-4xl border-l-2 border-burgundy pl-8 md:pl-12" data-testid="testimonial-featured">
            <blockquote className="font-serif text-2xl md:text-4xl font-light italic leading-snug text-burgundy">
              “{featured.quote}”
            </blockquote>
            <figcaption className="mt-8">
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-burgundy">{featured.name}</p>
              <p className="mt-1 text-sm text-charcoal/60">{featured.role}</p>
            </figcaption>
          </figure>
        </Reveal>
      )}
      <div className="mt-20 grid md:grid-cols-2 gap-12 lg:gap-16">
        {others.map((t, i) => (
          <Reveal key={`${t.name}-${i}`} delay={(i % 2) * 0.12}>
            <figure className="flex h-full flex-col justify-between border-t border-burgundy/40 pt-8" data-testid={`testimonial-${i}`}>
              <blockquote className="font-serif text-lg md:text-xl font-light italic leading-relaxed text-charcoal">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8">
                <p className="text-sm font-semibold uppercase tracking-[0.2em] text-burgundy">{t.name}</p>
                <p className="mt-1 text-sm text-charcoal/60">{t.role}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
